import { render } from "./location-content.vue?vue&type=template&id=3d910ae2"
import script from "./location-content.vue?vue&type=script&lang=js"
export * from "./location-content.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__